import R from "ramda";
import { Vue } from "vue-property-decorator";
import CurdForm from "@/components/BaseCurd/form";
import getStyles from "./utils/style";
import getLang from "./utils/lang";
import "./index.less";

import {
  noop,
  stopPropagation,
  isEmptyObject,
  transferStaticToFunc,
} from "./utils";

var index = 0;
var comps = [];

export default class renderUtils extends Vue {
  vm_index__ = null;
  vm_cache__ = {};
  get lang() {
    return getLang(this);
  }

  beforeCreate() {
    comps[index] = 0;
    this.vm_index__ = index++;
  }

  beforeUpdate() {
    comps[this.vm_index__] = 0;
  }

  setState(key) {
    return (value) => (this[key] = value);
  }

  deleteEleFromArrayState(key) {
    return (value) => this[key].splice(R.indexOf(value, this[key]), 1);
  }

  appendEleToArrayState(key) {
    return (value) => this[key].append(value);
  }

  modifyEleInArrayState(key, findKey = "id") {
    const getFindFn = (value) => (v) => v[findKey] == value;
    const findIndex = R.pipe(
      R.prop(findKey),
      getFindFn,
      R.findIndex(R.__, this[key])
    );
    return (value) => (this[key][findIndex(value)] = value);
  }

  renderTable(props) {
    const {
      actions = {},
      pagination = false,
      canFixedHead = false,
      rowKey = "id",
    } = props;

    const currIndex = comps[this.vm_index__]++;
    const selectRowKey =
      this.vm_cache__[currIndex] && this.vm_cache__[currIndex][rowKey];

    const actionsRow = {
      title: this.lang.actions,
      // fixed: "left",
      // width: 200,
      key: "action",
      customRender: this.renderActions(actions),
    };

    const columns = isEmptyObject(actions)
      ? props.columns
      : [actionsRow, ...props.columns];
    return (
      <ml-table
        size="small"
        rowKey={rowKey}
        canChangeColWidth={true}
        canFixedHead={canFixedHead}
        pagination={pagination}
        defaultExpandAllRows={true}
        dataSource={props.dataSource}
        scroll={props.scroll ? props.scroll : null}
        columns={columns}
        rowSelection={props.rowSelection}
        customRow={(row) => ({
          on: {
            click: () => {
              this.$set(this.vm_cache__, currIndex, row);
            },
          },
        })}
        selectRowKey={selectRowKey}
      ></ml-table>
    );
  }

  renderActions(actions) {
    const {
      edit: {
        action: editAction = noop,
        disabled: editDisabled = false,
        acl: editAcl = "",
      } = {},
      del: {
        action: delAction = noop,
        disabled: delDisabled = false,
        acl: delAcl = "",
        style:color = ""
      } = {},
    } = actions;

    const hasEdit = !!actions.edit;
    const hasDel = !!actions.del;

    return (row) => {
      const popProp = {
        slot: (
          <a
            disabled={transferStaticToFunc(delDisabled)(row)}
            onClick={() => delAction(row)}
            v-acl={delAcl}
            style ={color}
          >
            {this.lang.delete}
          </a>
        ),
        disabled: transferStaticToFunc(delDisabled)(row),
        title: this.lang.delete_tips,
      };

      return (
        <div>
          {hasDel ? this.renderPopconfirmWrapper(popProp) : null}
          {hasEdit && hasDel ? <a-divider type="vertical" /> : null}
          {hasEdit ? (
            <a
              disabled={transferStaticToFunc(editDisabled)(row)}
              onClick={(e) => {
                stopPropagation(e);
                editAction(row);
              }}
              v-acl={editAcl}
            >
              {this.lang.edit}
            </a>
          ) : null}
        </div>
      );
    };
  }

  renderPopconfirmWrapper({
    slot,
    disabled = false,
    title = this.lang.delete_tips,
    rest = {},
  }) {
    const isComponent = !!slot.componentOptions;
    let confirm = noop;
    if (isComponent) {
      confirm = slot.componentOptions.listeners.click;
      slot.componentOptions.listeners.click = stopPropagation;
    } else {
      confirm = slot.data.on.click;
      slot.data.on.click = stopPropagation;
    }

    return (
      <a-popconfirm
        disabled={disabled}
        onConfirm={confirm}
        title={title}
        okText={this.lang.ok}
        cancelText={this.lang.cancel}
        {...rest}
      >
        {slot}
      </a-popconfirm>
    );
  }

  getRenderDialogFunction(props) {
    const {
      show,
      footer = null,
      width = 520,
      cancel,
      ok = noop,
      title = this.lang.create,
      bodyStyle = {},
      confirmLoading,
    } = props;

    const setFooter = {
      props: {},
    };

    if (footer !== "default") (setFooter.props as any).footer = footer;

    return (slot) => (
      <a-modal
        class="render-util-modal"
        bodyStyle={bodyStyle}
        onCancel={() => cancel(false)}
        onOk={ok}
        title={title}
        visible={show}
        destroyOnClose={true}
        width={width}
        {...setFooter}
        maskClosable={false}
        confirmLoading={confirmLoading}
      >
        {slot}
      </a-modal>
    );
  }

  renderCurdForm(props) {
    const {
      schema,
      editdata = {},
      type = "create",
      submit = noop,
      cancel,
      hidden = [],
      footer,
      ref,
    } = props;
    const append: any = {};
    if (ref) append.ref = ref;

    return (
      <CurdForm
        hidden={hidden}
        type={type}
        schema={schema}
        onSubmit={submit}
        defaultValue={editdata}
        onCancel={() => cancel(false)}
        footer={footer ? false : true}
        {...append}
      />
    );
  }

  renderDialogWithTable(props) {
    const slot = this.renderTable(props);

    return this.getRenderDialogFunction(props)(slot);
  }

  renderDialogWithForm(props) {
    const form = this.renderCurdForm(props);
    if (props.ok && props.ref !== undefined) {
      const cache = props.ok;
      props.ok = () => {
        (this.$refs[props.ref] as any)
          .manualSubmitWithLoading()
          .then(([value, setLoading]) => {
            cache(value, setLoading);
          });
      };
    }
    return this.getRenderDialogFunction(props)(form);
  }

  renderDialogWithStepForm(props) {
    let loading = false;
    const { current, steps, changeCurr, cancel } = props;
    const maxlength = steps.length - 1;
    const renderStep = ({ title }) => <a-step title={title} />;

    const renderLoading = loading ? (
      <div style={getStyles("mask")}>
        <a-spin size="large" />
      </div>
    ) : null;

    const slot = (
      <div style={getStyles("wrapper", "relative", "padBtm0")}>
        <a-steps
          current={current}
          size="small"
          style={getStyles("margBtm30", "maxW600")}
        >
          {R.map(renderStep, steps)}
        </a-steps>
        {steps[current].render()}
        {renderLoading}
      </div>
    );

    const onNext = () => {
      loading = true;
      const next = steps[current].next || noop;
      Promise.resolve(next())
        .then((bool) => {
          if (typeof bool === "undefined") bool = true;
          if (!bool) return;
          if (current === maxlength) {
            cancel();
            changeCurr(0);
          } else {
            changeCurr(current + 1)
          }
        })
        .catch(noop)
        .finally(() => {
          setTimeout(() => {
            loading = false
          })
        });
    };

    props.footer = (
      <a-button onClick={onNext} type="primary" loading={loading}>
        {current < maxlength ? this.lang.next_step : this.lang.sure}
      </a-button>
    );

    const cancelCb = (bool) => {
      changeCurr(0);
      cancel(bool);
    };

    props.cancel = cancelCb;

    return this.getRenderDialogFunction(props)(slot);
  }

  renderDialogWithTabsForm(props) {
    const { tabs, tab, changeTab } = props;

    if (props.ok && props.ref !== undefined) {
      const cache = props.ok;
      props.ok = () => {
        (this.$refs[props.ref] as any)
          .manualSubmitWithLoading()
          .then(([value, setLoading]) => {
            cache(value, setLoading);
          });
      };
    }

    const renderTab = ({ title, key }, index) => (
      <a-button
        type={tab === index ? "primary" : "default"}
        onClick={() => changeTab(key)}
      >
        {title}
      </a-button>
    );

    const slot = (
      <div>
        <a-button-group style={getStyles("margBtm30", "center")}>
          {R.addIndex(R.map)(renderTab, tabs)}
        </a-button-group>
        {this.renderCurdForm({
          ...props,
        })}
      </div>
    );

    return this.getRenderDialogFunction(props)(slot);
  }
}
